// TODO pass in a locale
export const formatCurrency = value => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(value)
